<template>
  <v-layout row>
    <v-flex>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>What's Next</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="loadTasks()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list three-line>
          <template v-for="(item, index) in items">
            <v-list-item
              :key="item.title"
              ripple
              @click="actionOnTask(item.action, item.postID)"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.text }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon ripple>
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index + 1 < items.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import config from '@/config'
  import PostAPI from '../Post/postApi'
  import CampaignAPI from '../Campaign/campaignAPIs'
  import ClientAPI from '../Client/clientAPIs'
  import { mapState } from 'vuex'

  export default {
    name: 'ClientTasks',
    data () {
      return {
        items: []
      }
    },

    methods: {
      loadTasks() {
        this.items = []
        // this.checkForVendorCreationForm()
        this.checkForPendingPosts()
        this.checkForPendingCampaigns()
        this.checkForPairingCampaigns()
        this.checkForLivePosts()
      },
      actionOnTask(task, id) {
        switch (task) {
          case 'viewPost':
            this.$router.push({path: '/clients/posts', query: { action: 'view', id: id }});
            break;
          case 'viewCampaign':
            this.$router.push({path: '/clients/campaigns'});
            break;
          case 'viewPublished':
            this.$router.push({path: '/clients/posts'});
            break;
          case 'viewPairingInfluencersCampaign':
            this.$router.push({path: '/clients/campaigns'});
            break;
          case 'goToVendorForm':
            this.$router.push({path: '/client/vendor-creation-form'});
        }
      },
      checkForVendorCreationForm() {
        ClientAPI
          .getClient(this.user.clientID)
          .then(response => {
            let client = response
            if (!client.acceptTerms) {
              this.items.push({
                action: 'goToVendorForm',
                title: 'Complete Vendor Creation Form',
                text: `You need to complete the vendor creation form to activate your account`
              })
            }
          })
      },
      checkForPairingCampaigns() {
        let status = config.campaignStatus.PAIRING_INFLUENCER
        CampaignAPI
          .paginate({
            page: 1,
            status: status
          })
          .then(response => {
            let campaigns = response.campaigns
            if (campaigns.length > 0) {
              this.items.push({
                action: 'viewPairingInfluencersCampaign',
                title: 'Approve the Creator Line Up',
                text: `${campaigns.length} campaign(s) in pairing step`
              })
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      checkForPendingCampaigns() {
        let status = config.campaignStatus.PENDING_CLIENT_APPROVAL
        CampaignAPI
          .paginate({
            page: 1,
            status: status
          })
          .then(response => {
            let campaigns = response.campaigns
            if (campaigns.length > 0) {
              this.items.push({
                action: 'viewCampaign',
                title: 'Pending your approval',
                text: `${campaigns.length} campaign(s) waiting your approval`
              })
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      checkForPendingPosts() {
        let status = config.postStatus.CLIENT_PENDING
        PostAPI.getPost({status, page: 1})
          .then(response => {
            let posts = response.posts
            if (posts.length > 0) {
              this.items.push({
                action: 'viewPost',
                title: 'Pending your approval',
                text: `${posts.length} draft(s) to vet.`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      checkForLivePosts() {
        let status = config.postStatus.LIVE
        PostAPI.getPost({status})
          .then(response => {
            let posts = response.posts
            if (posts.length > 0) {
              this.items.push({
                action: 'viewPublished',
                title: 'See the live posts',
                text: `${posts.length} posts published`
              })
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    mounted() {
      this.loadTasks()
    },
    computed: {
      ...mapState(['user']),
      currentUserID: function () {
        return this.$store.state.user.id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientTasks.vue?18bc23a8